import { render, staticRenderFns } from "./frimResult.vue?vue&type=template&id=3fcf026c&scoped=true&"
import script from "./frimResult.vue?vue&type=script&lang=js&"
export * from "./frimResult.vue?vue&type=script&lang=js&"
import style0 from "./frimResult.vue?vue&type=style&index=0&id=3fcf026c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf026c",
  null
  
)

export default component.exports